<template>
    <div v-if="((currentUserHasRole('Administrator') || currentUserHasRole('Membership')) && !loading)">
      <h3 class="title mb-3">{{$t('manage-options.title')}}</h3>
      <v-divider class="my-6"></v-divider>

      <!-- <h3 class="title mb-3">Import CSV</h3> -->
      <!-- <RatesCSVUploadForm :unit="unit" /> -->
      <!-- <v-divider class="my-6"></v-divider> -->

      <h3 class="title mb-3">{{$t('manage-options.section-delete-unit.title')}}</h3>
      <div v-if="this.unit.bookings.length === 0">
        <p>{{$t('manage-options.section-delete-unit.description')}}</p>
        <confirmation
          :title="$t('manage-options.actions.delete-unit.confirmation-header', { unit_name: this.unit.name })"
          :submitHandler="deleteUnitSubmitHandler"
          :entity="this.unit"
        >
          <template v-slot:activator="props">
            <v-btn small color="error" rounded dark @click.stop="props.showDialog">{{ $t('global-terms.delete') }}</v-btn>
          </template>
          <template v-slot:body>
            <p>{{$t('manage-options.actions.delete-unit.confirmation-body')}}</p>
          </template>
        </confirmation>
      </div>
      <div v-else>
        <p>{{$t('manage-options.section-delete-unit.post-description')}}</p>
      </div>

      <v-divider class="my-6"></v-divider>

      <h3 class="title mb-3">{{$t('manage-options.section-delete-third-party-bookings.title')}}</h3>
      <div v-if="Object.keys(externalBookings).length > 0">
        <p>{{$t('manage-options.section-delete-third-party-bookings.description')}}</p>
        <confirmation
          :title="$t('manage-options.actions.delete-third-party-bookings.confirmation-header')"
          :submitHandler="deleteThirdPartyBoookingsSubmitHandler"
          :entity="this.unit"
        >
          <template v-slot:activator="props">
            <v-btn small color="error" rounded @click.stop="props.showDialog">{{ $t('global-terms.delete') }}</v-btn>
          </template>
          <template v-slot:body>
            <p>{{$t('manage-options.actions.delete-third-party-bookings.confirmation-body')}}</p>
          </template>
        </confirmation>
      </div>
      <div v-else>
        <p>{{$t('manage-options.section-delete-third-party-bookings.no-bookings-description')}}</p>
      </div>
    </div>
  </template>
<script>
import { mapActions, mapState } from 'pinia'
import { clone } from 'ramda'
import Confirmation from '../../../../../components/dialogs/Confirmation'
// import RatesCSVUploadForm from './RatesCSVUploadForm.vue'
import { useBookingStore, useUnitStore, useUserStore } from '../../../../../stores'

export default {
  name: 'manage-options-tab',
  data () {
    return {
      loading: true,
    }
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    place: {
      type: Object,
      required: true,
    },
  },
  methods: {
    clone,
    ...mapActions(useUnitStore, [
      'httpDeleteUnit',
      'httpUpdateUnit',
      'httpDeleteUnitThidPartyBookings',
    ]),
    deleteUnitSubmitHandler (unit) {
      const clonedUnit = clone(unit)
      return this.httpDeleteUnit({ unit: clonedUnit })
    },
    deleteThirdPartyBoookingsSubmitHandler (unit) {
      const clonedUnit = clone(unit)
      return this.httpDeleteUnitThidPartyBookings({ unit: clonedUnit })
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useBookingStore, {
      bookingsFindByIds: 'findByIds',
      externalBookingsFindByIds: 'findExternalByIds',
    }),
    externalBookings () {
      return this.externalBookingsFindByIds(this.unit.bookings)
    },
    bookings () {
      return this.bookingsFindByIds(this.unit.bookings)
    },
  },
  components: {
    Confirmation,
    // RatesCSVUploadForm,
  },
  created () {
    this.loading = false
  },
}
</script>
